/*eslint-enable*/
( function () {
	'use strict';

	const ctaBold = document.querySelectorAll( '.cta-bold' );

	/**
	 * Helper Function for debouncing
	 */
	function debounce( func, wait, immediate ) {
		var timeout;
		return function () {
			var context = this, args = arguments;

			/**
			 * Set timeout for debounce
			 */
			var later = function () {
				timeout = null;
				if ( !immediate ) func.apply( context, args );
			};

			var callNow = immediate && !timeout;

			clearTimeout( timeout );
			timeout = setTimeout( later, wait );
			if ( callNow ) func.apply( context, args );

		};
	}

	let windowWidth = window.innerWidth;

	const checkWidth = debounce( function () {

		if ( window.innerWidth != windowWidth ) {

			ctaBold.forEach( ( i ) => {

				const ctaBoldRow = i.querySelectorAll( '.cta-bold__row' );

				//make sure the row exists
				if ( '' !== ctaBoldRow ) {

					ctaBoldRow.forEach( ( parent ) => {

						const children = Array.from( parent.children );
						//set a width var
						let totalWidth = 0;
						//reset the width
						children.forEach( ( childItem ) => {
							totalWidth += childItem.getBoundingClientRect().width;
						} );
						const roundedWidth = Math.round( totalWidth );
						//set row width
						parent.style.width = roundedWidth  + 'px';

					} );
				}
			} );
		}

	}, 250 );

	/**set initial widths, clone items**/
	ctaBold.forEach( ( i ) => {

		const ctaBoldRow = i.querySelectorAll( '.cta-bold__row' );

		//make sure the row exists
		if ( '' !== ctaBoldRow ) {

			//duplicate any rows
			ctaBoldRow.forEach( ( parent ) => {

				const children = Array.from( parent.children );
				//set a width var
				let totalWidth = 0;
				//duplicate nodes
				children.forEach( ( childItem ) => {
					totalWidth += childItem.getBoundingClientRect().width;
					const clonedItem = childItem.cloneNode( true );
					parent.appendChild( clonedItem );
				} );
				const roundedWidth = Math.round( totalWidth * 2 );
				//set row width
				parent.style.width = roundedWidth + 'px';

			} );
		}
	} );

	//resize listener
	window.addEventListener( 'resize', checkWidth ); /* On Resize */

}() );
/*eslint-disable*/

